import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 3.75,
  },
  searchBar: {
    width: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    height: "fit-content",
  },
  smallSearchBar: {
    width: "100%",
  },
}));
